import React, { Component } from 'react';
import AccessDeniedBehavior from '../../services/enums/accessDeniedBehavior';
import Permissions from '../../services/enums/permissions';
import LoggedInUserTabs from './loggedInUserTabs';
import authorize from '../authorization/authorize';
import PrivateRouteWrapper from '../router/privateRouteWrapper';

export default class LoggedInUserContainer extends Component {

    render() {

        return (
            <PrivateRouteWrapper>
                    <LoggedInUserTabs />
            </PrivateRouteWrapper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/myProfile/index.jsx